import {
  Backdrop,
  Box,
  CircularProgress,
  Paper,
  Typography,
} from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import { DataGrid } from "@mui/x-data-grid";
import { React, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Progress_bar from "./Progress_bar";
import { setState } from "./dashBoardSlice";

export default function RunningPeriodStatus() {
  const state = useSelector((store) => store.dashboard);
  const dispatch = useDispatch();
  const { isLoading, drawerOpen, scenarios } = state;

  const columns = [
    {
      field: "scenarioName",
      headerName: "Scenario Name",
      flex: 2,
    },
    {
      field: "quota",
      headerName: "Quota",
      flex: 1,
      valueFormatter: (params) => {
        const formattedValue = Number(params.value)?.toLocaleString();
        return formattedValue;
      },
    },
    {
      field: "consumption",
      headerName: "Quota Consumption",
      flex: 2,
      renderCell: (cellValues) => {
        let progressBarValue = 0;
        if (cellValues.row.quota == 0.0) {
          progressBarValue = 0;
        } else {
          progressBarValue = (
            (cellValues.row.consumption / cellValues.row.quota) *
            100
          ).toFixed();
        }
        return (
          <Box sx={{ width: "100%" }}>
            <Progress_bar
              bgcolor="#007bff"
              progress={progressBarValue}
              progressContent={cellValues.row.consumption?.toLocaleString()}
              height={30}
            />

            <label>{progressBarValue + "%"}</label>
          </Box>
        );
      },
    },
    {
      field: "orderStatus",
      headerName: "Order Status",
      flex: 2,
    },
  ];

  useEffect(() => {
    dispatch(setState("scenarios", []));
    dispatch(
      setState("approvalStats", {
        scenarioCount: 0,
        quotaCount: 0,
        quotaModificationsCount: 0,
      })
    );
  }, []);

  if (!scenarios) {
    return (
      <Box>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress />
        </Backdrop>
      </Box>
    );
  }

  return (
    <>
      {scenarios.length > 0 ? (
        <Paper
          elevation={0}
          sx={{
            width: drawerOpen ? "75%" : "100%",
            borderRadius: 2,
            paddingTop: 2,
          }}
        >
          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{ color: "blue.main" }}
          >
            Running Period Status
          </Typography>

          <DataGrid
            style={{ maxHeight: "calc(100vh - 130px)" }}
            disableColumnMenu
            sx={{
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: "normal",
              },
              "& .MuiDataGrid-columnHeader": {
                position: "sticky",
              },
              "& .MuiDataGrid-columnHeaders": {
                maxHeight: "168px !important",
              },
            }}
            rowHeight={70}
            rows={scenarios || []}
            columns={columns}
            getRowId={(scenarios) => scenarios?.scenarioID}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20, 50, 100]}
            disableRowSelectionOnClick
          />
        </Paper>
      ) : (
        <Paper
          elevation={0}
          sx={{
            width: drawerOpen ? "75%" : "100%",
            borderRadius: 2,
            paddingTop: 2,
          }}
        >
          <Typography variant="subtitle1" sx={{ color: "blue.main", mt: 1 }}>
            Running Period Status
          </Typography>
          <DataGrid
            sx={{ height: "300px", mt: 1 }}
            rows={[]}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            disableColumnMenu
            pageSizeOptions={[20, 50, 100]}
            disableRowSelectionOnClick
          />
        </Paper>
      )}
    </>
  );
}
